module.exports = __webpack_public_path__ + "img/ATOM.7463f436.png";